import { Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Recruitment", href: "#recruitment" },
  { label: "Advisory", href: "#advisory" },
  { label: "Pre-Opening", href: "#pre-opening" },
  { label: "Employers", href: "#employers" },
  { label: "Candidates", href: "#candidates" },
  { label: "Contact", href: "#contact" },
];

const Footer = () => (
  <footer data-testid="footer" className="bg-ink text-ivory border-t border-ivory/10">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-20">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img
            src="/images/br-logo-official.jpg"
            alt="BR Hospitality monogram"
            className="w-16 h-16 object-cover mb-6"
          />
          <p className="font-serif text-2xl tracking-[0.15em]">BR HOSPITALITY</p>
          <p className="font-serif italic text-bronze mt-3">People. Passion. Performance.</p>
        </div>
        <div className="lg:col-span-4">
          <nav className="grid grid-cols-2 gap-x-8 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace("-", "")}`}
                onClick={() => scrollToId(l.href)}
                className="text-left text-[11px] tracking-[0.2em] uppercase text-ivory/50 hover:text-bronze transition-colors duration-500"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="lg:col-span-3 flex lg:justify-end items-start gap-4">
          <a
            data-testid="footer-linkedin"
            href="https://www.linkedin.com/company/brhospitality"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="w-10 h-10 border border-ivory/20 flex items-center justify-center text-ivory/60 hover:text-bronze hover:border-bronze transition-all duration-500"
          >
            <Linkedin size={15} strokeWidth={1.5} />
          </a>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-[10px] tracking-[0.2em] uppercase text-ivory/35">
          © BR Hospitality. All rights reserved.
        </p>
        <div className="flex gap-8">
          <Link
            data-testid="footer-privacy"
            to="/privacy"
            className="text-[10px] tracking-[0.2em] uppercase text-ivory/35 hover:text-bronze transition-colors duration-500"
          >
            Privacy Policy
          </Link>
          <Link
            data-testid="footer-terms"
            to="/terms"
            className="text-[10px] tracking-[0.2em] uppercase text-ivory/35 hover:text-bronze transition-colors duration-500"
          >
            Terms &amp; Conditions
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
